export const documents = {
  en: {
    // ââ Termination: the legal basis ââââââââââââââââââââââââââââââââââââââââ
    terminationBasisTitle: "The legal basis of this termination",
    terminationBasisNote: "An article number on a termination agreement is the legal basis of the termination. Choose the article it rests on and who ended the relationship; the clause is written from those two.",
    terminationArticle: "Article of the Labour Law",
    terminationInitiator: "Who ended the relationship",
    terminationChoose: "Choose…",
    terminationArticleOption: "Article {n} — {summary}",
    initiatorEmployer: "The employer",
    initiatorEmployee: "The employee",
    initiatorMutual: "By agreement of both parties",
    terminationArticle77Warning: "Article 77 concerns the compensation owed when a contract is ended without a valid reason. Make sure it is the basis you mean before issuing.",
    terminationBasisIncomplete: "Choose the article and the initiating party before selecting an employee.",

    salaryCertificate: "Salary certificate",
    employmentCertificate: "Employment certificate",
    experienceLetter: "Experience certificate",
    warningLetter: "Warning letter",
    terminationLetter: "Termination letter",
    finalSettlement: "Final settlement",
    leaveEncashmentCertificate: "Leave encashment certificate",
    payslip: "Payslip",
    loanAcknowledgement: "Loan acknowledgement",
    warningNote: "A disciplinary record. It becomes part of the employee's file and cannot be edited once issued.",
    issue: "Issue",
    voidTitle: "Void this document?",
    voidBody: "The document stays on file marked void, so the record of it being issued is not lost.",
    voidReason: "Why is it being voided?",
    deleteAction: "Delete permanently",
    deleteTitle: "Delete this document",
    deleteReason: "Reason",
    status: "Status",
    statusIssued: "Issued",
    statusVoided: "Voided",
    voidedOn: "Voided {date}",
    voidedOnBecause: "Voided {date} — {reason}",
    voidAction: "Void document",

    issuedOn: "Issue date",
    preview: "Preview",

    layoutTitle: "Document layout",
    layoutNote: "Every generated document renders on top of the official company stationery below, inside these margins (in millimetres) — one setting, used by every document kind.",
    stationeryHeading: "Official stationery",
    stationeryNote: "One PNG holding the logo, header, footer and watermark. Every document is generated on top of it. Replacing it here changes the branding on every future document immediately — no document template ever needs editing.",
    stationeryNone: "No stationery uploaded yet. Documents will generate on a blank page until one is uploaded.",
    stationeryUpload: "Upload stationery",
    stationeryReplace: "Replace stationery",
    stationeryRemove: "Remove",
    stationeryPreviewAlt: "Current official stationery",
    stationeryInvalidType: "Please choose a PNG file.",
    stationeryUploading: "Uploading…",
    marginTop: "Top margin (mm)",
    marginBottom: "Bottom margin (mm)",
    marginLeft: "Left margin (mm)",
    marginRight: "Right margin (mm)",

    descSalaryCertificate: "Confirms current salary — usually for a bank.",
    descEmploymentCertificate: "Confirms the employee currently works here.",
    descExperienceLetter: "Confirms employment dates and role.",
    descWarningLetter: "A disciplinary record for the employee's file.",
    descTerminationLetter: "Formal notice of ending employment.",
    descFinalSettlement: "End-of-service dues and the final payment.",
    descLeaveEncashmentCertificate: "Receipt for one leave payout — the days and amount actually paid.",
    descPayslip: "Monthly earnings and deductions breakdown.",
    descLoanAcknowledgement: "Confirms receipt of a salary advance and the terms of repayment.",

    wizardStep1Title: "What document do you need?",
    wizardStep2Title: "Who is it for?",
    languageLabel: "Document language",
    languageArabic: "العربية",
    languageEnglish: "English",
    wizardStep2TitlePayslip: "Which payslip?",
    wizardStep2TitleLoan: "Which loan?",
    wizardStep3Title: "Edit & preview",
    wizardStepIssuedTitle: "Issued",
    liveEditNote: "Everything below updates as you type — this is exactly what will be issued.",
    contentOverflow: "This document exceeds the available space on the official paper. Shorten the content so it finishes above the dashed line before issuing — a second page is not available for this document.",
    searchEmployee: "Search by name, employee number, or national ID",
    noEmployeesFound: "No employees match that search.",
    choosePeriod: "Pay period",
    noRunsForPeriod: "No payroll runs for this period.",
    searchLoanEmployee: "Search by employee name",
    noLoansFound: "No loans match that search.",
    wizardStep2TitleEncashment: "Which payout?",
    searchEncashmentEmployee: "Search by employee name",
    noEncashmentsFound: "No leave payouts match that search.",
    changeDocumentType: "Change document type",
    changeEmployee: "Change employee",
    issueDocument: "Issue document",
    documentIssued: "Document issued",
    documentIssuedNote: "This document is saved on the employee's Documents tab. Print it or save it as a PDF from the browser's print dialog.",
    printOrSavePdf: "Print / Save as PDF",
    viewDocument: "View document",
    startAnother: "Generate another document",
    goToDocuments: "Generate a document",
    issuedDocuments: "Documents issued by the system",
    // Issuing sends nothing. Sending is its own action — see SendDocumentButton.tsx.
    sendToEmployee: "Send to the employee",
    sendAgain: "Send again",
    sentOn: "Sent to the employee on {when}.",
    sendConfirmTitle: "Send this to the employee?",
    sendAgainTitle: "Send this a second time?",
    sendAgainBody: "The employee was already sent this document on {when}. Sending again delivers another copy.",
    handOverHint: "This kind is normally handed over in person: a warning or a termination letter belongs in a conversation, and a loan acknowledgement is signed as the advance changes hands. Send it only if you mean to email it instead.",
    // Moved off the final settlement document itself — see FinalMonthPayrollNotice.tsx.
    // The wording is the document's, verbatim, minus the one positional word
    // ("below") that stopped being true once it left the page it referred to.
    payrollNoticeApproved: "WARNING: salary for {month} of {amount} was already paid by payroll run #{run}. This settlement also charges worked-days salary for the same period — confirm the employee is not paid twice.",
    payrollNoticeDraft: "A payroll run for {month} (#{run}) exists and is not yet approved. If it is approved, the same period is paid twice.",
    conflictRunPaid: "Payroll run already paid: {amount}",
    conflictWorkedDays: "This settlement charges for worked days: {amount}",
    conflictExcess: "The run paid {amount} more than the days worked are worth. Dropping the line below does not recover that — decide separately how it is handled.",
    conflictShortfall: "The run paid less than the days worked are worth. {amount} is still owed.",
    conflictChoose: "Choose how to resolve this before issuing, or reverse the run's approval. A paid run cannot be reversed — correct it in the next period instead.",
    conflictDropWorkedDays: "The run covered it — do not charge worked days again",
    conflictSettleDifference: "Settle only the difference",
    conflictResolved: "The worked-days line has been netted against the payroll run. The figures above and the document now reflect that.",
    conflictUndo: "Undo",
    payrollNoticeMissing: "No payroll run exists for {month} — the worked-days salary is the only payment for that period.",
    generateHeading: "Generate Document",
    settingsHeading: "Document Settings",
    docType: "Document Type",
    reference: "Reference Number",
    downloadPdf: "Download PDF",
  },
  ar: {
    // ââ Termination: the legal basis ââââââââââââââââââââââââââââââââââââââââ
    terminationBasisTitle: "الأساس النظامي لإنهاء العلاقة",
    terminationBasisNote: "رقم المادة في اتفاق الإنهاء هو الأساس النظامي للإنهاء. اختر المادة التي يستند إليها الإنهاء ومن أنهى العلاقة؛ ويُكتب البند من هذين الاختيارين.",
    terminationArticle: "مادة نظام العمل",
    terminationInitiator: "من أنهى العلاقة",
    terminationChoose: "اختر…",
    terminationArticleOption: "المادة {n} — {summary}",
    initiatorEmployer: "صاحب العمل",
    initiatorEmployee: "الموظف",
    initiatorMutual: "باتفاق الطرفين",
    terminationArticle77Warning: "المادة (77) تتعلق بالتعويض المستحق عند إنهاء العقد دون سبب مشروع. تأكد أنها الأساس المقصود قبل الإصدار.",
    terminationBasisIncomplete: "اختر المادة والطرف المُنهي للعلاقة قبل اختيار الموظف.",

    salaryCertificate: "شهادة راتب",
    employmentCertificate: "شهادة تعريف بالعمل",
    experienceLetter: "شهادة خبرة",
    warningLetter: "خطاب إنذار",
    terminationLetter: "خطاب إنهاء خدمة",
    finalSettlement: "المخالصة النهائية",
    leaveEncashmentCertificate: "شهادة صرف بدل إجازة",
    payslip: "قسيمة راتب",
    loanAcknowledgement: "إقرار استلام سلفة",
    warningNote: "سجل تأديبي يصبح جزءاً من ملف الموظف ولا يمكن تعديله بعد الإصدار.",
    issue: "إصدار",
    voidTitle: "إلغاء هذا المستند؟",
    voidBody: "يبقى المستند في الملف مؤشراً عليه بالإلغاء، حتى لا يُفقد سجل إصداره.",
    voidReason: "سبب الإلغاء",
    deleteAction: "حذف نهائي",
    deleteTitle: "حذف هذه الوثيقة",
    deleteReason: "السبب",
    status: "الحالة",
    statusIssued: "صادرة",
    statusVoided: "ملغاة",
    voidedOn: "أُلغيت في {date}",
    voidedOnBecause: "أُلغيت في {date} — {reason}",
    voidAction: "إلغاء المستند",

    issuedOn: "تاريخ الإصدار",
    preview: "معاينة",

    layoutTitle: "تخطيط المستندات",
    layoutNote: "يتم إنشاء كل مستند فوق القرطاسية الرسمية للشركة أدناه، ضمن هذه الهوامش (بالمليمتر) — إعداد واحد يُستخدم في جميع أنواع المستندات.",
    stationeryHeading: "القرطاسية الرسمية",
    stationeryNote: "ملف PNG واحد يحتوي على الشعار والترويسة والتذييل والعلامة المائية. يُنشأ كل مستند فوقه. استبداله هنا يغيّر الهوية البصرية لكل مستند لاحق فوراً — دون الحاجة لتعديل أي قالب مستند.",
    stationeryNone: "لم يتم رفع قرطاسية بعد. ستُنشأ المستندات على صفحة فارغة حتى يتم رفع واحدة.",
    stationeryUpload: "رفع القرطاسية",
    stationeryReplace: "استبدال القرطاسية",
    stationeryRemove: "إزالة",
    stationeryPreviewAlt: "القرطاسية الرسمية الحالية",
    stationeryInvalidType: "الرجاء اختيار ملف من نوع PNG.",
    stationeryUploading: "جارٍ الرفع…",
    marginTop: "الهامش العلوي (مم)",
    marginBottom: "الهامش السفلي (مم)",
    marginLeft: "الهامش الأيسر (مم)",
    marginRight: "الهامش الأيمن (مم)",

    descSalaryCertificate: "تأكيد الراتب الحالي — عادة للبنك.",
    descEmploymentCertificate: "تأكيد أن الموظف يعمل حالياً لدى الشركة.",
    descExperienceLetter: "تأكيد فترة العمل والمسمى الوظيفي.",
    descWarningLetter: "سجل تأديبي في ملف الموظف.",
    descTerminationLetter: "إشعار رسمي بإنهاء العمل.",
    descFinalSettlement: "مستحقات نهاية الخدمة والمبلغ النهائي.",
    descLeaveEncashmentCertificate: "إيصال عملية صرف إجازة — بالأيام والمبلغ المصروف فعلاً.",
    descPayslip: "تفصيل مستحقات واستقطاعات الشهر.",
    descLoanAcknowledgement: "إقرار باستلام سلفة على الراتب وشروط سدادها.",

    wizardStep1Title: "ما المستند الذي تحتاجه؟",
    wizardStep2Title: "لمن هذا المستند؟",
    languageLabel: "لغة المستند",
    languageArabic: "العربية",
    languageEnglish: "English",
    wizardStep2TitlePayslip: "أي قسيمة راتب؟",
    wizardStep2TitleLoan: "أي سلفة؟",
    wizardStep3Title: "تعديل ومعاينة",
    wizardStepIssuedTitle: "تم الإصدار",
    liveEditNote: "كل ما يظهر أدناه يتحدث أثناء الكتابة — هذا هو المستند الذي سيصدر تماماً كما تراه.",
    contentOverflow: "هذا المستند يتجاوز المساحة المتاحة على الورقة الرسمية. يرجى تقصير المحتوى ليتم ضمن الخط المتقطع قبل الإصدار — لا تتوفر صفحة ثانية لهذا المستند.",
    searchEmployee: "ابحث بالاسم أو الرقم الوظيفي أو رقم الهوية",
    noEmployeesFound: "لا يوجد موظفون مطابقون لهذا البحث.",
    choosePeriod: "فترة الراتب",
    noRunsForPeriod: "لا توجد مسيرات رواتب لهذه الفترة.",
    searchLoanEmployee: "ابحث باسم الموظف",
    noLoansFound: "لا توجد سلف مطابقة لهذا البحث.",
    wizardStep2TitleEncashment: "أي عملية صرف؟",
    searchEncashmentEmployee: "ابحث باسم الموظف",
    noEncashmentsFound: "لا توجد عمليات صرف إجازة مطابقة لهذا البحث.",
    changeDocumentType: "تغيير نوع المستند",
    changeEmployee: "تغيير الموظف",
    issueDocument: "إصدار المستند",
    documentIssued: "تم إصدار المستند",
    documentIssuedNote: "تم حفظ هذا المستند في تبويب مستندات الموظف. اطبعه أو احفظه كملف PDF من نافذة الطباعة في المتصفح.",
    printOrSavePdf: "طباعة / حفظ كـ PDF",
    viewDocument: "عرض المستند",
    startAnother: "إصدار مستند آخر",
    goToDocuments: "إصدار مستند",
    issuedDocuments: "المستندات الصادرة من النظام",
    sendToEmployee: "إرسال للموظف",
    sendAgain: "إعادة الإرسال",
    sentOn: "أُرسل إلى الموظف بتاريخ {when}.",
    sendConfirmTitle: "إرسال هذا المستند إلى الموظف؟",
    sendAgainTitle: "إرسال المستند مرة أخرى؟",
    sendAgainBody: "سبق إرسال هذا المستند إلى الموظف بتاريخ {when}. إعادة الإرسال ترسل نسخة أخرى.",
    handOverHint: "يُسلَّم هذا النوع عادةً باليد: خطاب الإنذار أو إنهاء الخدمة يُسلَّم في لقاء مباشر، وإقرار السلفة يُوقَّع عند تسليم المبلغ. لا ترسله إلا إذا كنت تقصد إرساله بالبريد.",
    payrollNoticeApproved: "تنبيه: صُرف راتب شهر {month} بمبلغ {amount} عبر مسير الرواتب رقم {run}. تحتسب هذه المخالصة أيضاً راتب أيام العمل عن الفترة نفسها — تحقق من عدم صرف المبلغ مرتين.",
    payrollNoticeDraft: "يوجد مسير رواتب لشهر {month} (رقم {run}) لم يُعتمد بعد. إن اعتُمد، فسيُصرف راتب الفترة نفسها مرتين.",
    conflictRunPaid: "المبلغ المصروف عبر مسير الرواتب: {amount}",
    conflictWorkedDays: "ما تحتسبه هذه المخالصة عن أيام العمل: {amount}",
    conflictExcess: "صرف المسير {amount} زيادة عن قيمة أيام العمل الفعلية. إسقاط البند أدناه لا يسترد هذا المبلغ — قرر طريقة معالجته بشكل منفصل.",
    conflictShortfall: "صرف المسير أقل من قيمة أيام العمل. لا يزال مستحقاً {amount}.",
    conflictChoose: "اختر طريقة المعالجة قبل الإصدار، أو ألغِ اعتماد المسير. المسير المصروف لا يمكن إلغاؤه — صحّحه في الفترة التالية بدلاً من ذلك.",
    conflictDropWorkedDays: "المسير غطّاها — لا تحتسب أيام العمل مرة أخرى",
    conflictSettleDifference: "سدّد الفرق فقط",
    conflictResolved: "تمت مقاصة بند أيام العمل مع مسير الرواتب. الأرقام أعلاه والمستند يعكسان ذلك الآن.",
    conflictUndo: "تراجع",
    payrollNoticeMissing: "لا يوجد مسير رواتب لشهر {month} — راتب أيام العمل هو الدفعة الوحيدة عن تلك الفترة.",
    generateHeading: "إصدار مستند",
    settingsHeading: "إعدادات المستندات",
    docType: "نوع المستند",
    reference: "الرقم المرجعي",
    downloadPdf: "تنزيل PDF",
  },
} as const;
